<template>
    <div class="row mt-3">
        <div class="col-6">
            <div class="card">
                <div class="card-header pb-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <span class="h4">{{ $t('emailtemplate.edit_title') }}</span>
                    </div>
                </div>
                <div class="card-body">
                    <p v-if="loading">{{ $t('general.loading') }}</p>

                    <div v-if="emailTemplate && editor_config">
                        <label for="subject">{{ $t('general.subject') }}</label>
                        <input
                            class="form-control"
                            :disabled="loading"
                            type="text"
                            id="subject"
                            v-model="formData.subject"
                        />
                        <br />

                        <label for="message">{{ $t('emailtemplate.message_label') }}</label>
                        <trumbowyg
                            v-model="formData.message"
                            :config="editor_config"
                            class="form-control"
                            name="bericht"
                        ></trumbowyg>
                        <br />

                        <ul class="list-unstyled">
                            <li v-for="mergefield of emailTemplate.mergefields" :key="mergefield.name">
                                {{ mergefield.name }}
                                <sup v-if="mergefield.pivot.required">{{ $t('emailtemplate.mergefield_required') }}</sup>
                            </li>
                        </ul>

                        <button class="btn btn-primary btn-sm float-right" @click="save">
                            {{ $t('general.save') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6">
            <div class="card">
                <div class="card-header pb-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <span class="h4">{{ $t('emailtemplate.preview_title') }}</span>
                    </div>
                </div>
                <div class="card-body" style="background-color:#edf2f7">
                    <div class="text-center">
                        <img :src="companyAssets + '/mail_logo.png'" />
                    </div>
                    <div style="background-color:#fff;padding:25px;" v-html="formData.message"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


    export default {

        data() {
            return {
                id: null,
                emailTemplate: null,
                formData: {
                    subject: null,
                    message: ' ',
                },
                loading: false,
                mergefields: [],
                editor_config: null,
            }
        },

        computed: {
            companyAssets() {
                return window.COMPANY_ASSETS;
            }
        },

        created() {

            this.id = this.$route.params.id;
            this.load();

            this.editor_config = this.$root.default_editor_config;
            this.editor_config.btns.push(['mergefields']);

            if (!this.editor_config.plugins) {
                this.editor_config.plugins = {};
            }

            let mergefields = [];

            if (this.mergefields.length) {
                for (let mergefield of this.mergefields) {
                    mergefields.push(mergefield.field);
                }
            } else {
                mergefields = [
                    '[[NAAM]]',
                    '[[CEREMONIE]]',
                    '[[LINK]]',
                    '[[CODE]]',
                ];
            }

            this.editor_config.plugins.mergefields = {
                mergefields: mergefields
            };


        },

        methods: {
            async load() {
                this.loading = true;

                try {
                    const response = await this.$http.get(`/api/email-templates/${this.id}`)
                    this.emailTemplate = response.data;

                    this.formData = {
                        ...this.emailTemplate
                    };

                } catch (exception) {
                    if(!exception.response || (exception.response && exception.response.status !== 401)) {
                        alert('Cannot load email template');
                    }
                }

                this.loading = false;
            },

            async save() {
                this.loading = true;

                try {
                    const response = await this.$http.put(`/api/email-templates/${this.id}`, this.formData)
                    this.emailTemplate = response.data;
                } catch (exception) {
                    if(!exception.response || (exception.response && exception.response.status !== 401)) {
                        alert('Cannot save email template');
                    }
                }

                this.loading = false;
            }
        }
    }

</script>
